<template>
    <div id="containerDecouverte" class="containerAgenda">
        <div class="enjeu">{{leTeasing}}</div>
        <h2>{{leTitre}}</h2>
        <div class="presentation" v-html="laDescription"></div>
        <div id="decouverte" class="propositions">
            <span v-if="!leTabProgramme">La programmation des prochaines séances de découverte est en cours</span>
            <div v-if="leTabProgramme" class="itemProgramme" v-for="(leEvenement, numEvenement) in leTabProgramme" v-bind:class="{complet : leEvenement.etat == 'COMPLET'}" >
                <span class="icone"></span>
                <a v-if="leEvenement.etat != 'COMPLET'" class="bouton" :href="leEvenement.url" target="_blank">{{leEvenement.libelle_url}}</a>
                <div>
                    <div class="titre gauche">{{leEvenement.titre}}</div>
                    <div v-if="leEvenement.etat == 'COMPLET'" class="complet gauche">COMPLET</div>
                    <div class="sousTitre clear">{{leEvenement.sous_titre}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Decouverte',
    props: {
            data: {
                type: Object
            }
    },
    data() {
        return {
            tmp:true,
        }
    },
    computed: {
        markOrientest() {
            return(this.$router.options.markOrientest);
        },
        leTitre() {
            if (this.data && this.data.label) {
                return(this.data.label);
            }
            if (this.markOrientest) {
                return("Découverte Orient’Est PRO")
            }
            return("Découverte Lorfolio")
        },
        leTeasing() {
            if (this.data && this.data.teasing) {
                return(this.data.teasing);
            }
            if (this.markOrientest) {
                return("Explorez la face PRO d’Orient’Est");
            }
            return("Explorez la face pro de Lorfolio !")
        },
        laDescription() {
            if (this.data && this.data.description) {
                return(this.data.description); // description, teasing
            }
            if (this.markOrientest) {
                return("En deux heures, faites le tour des services d’Orient’Est PRO, et abordez les outils du compte personnel Mon Orient’Est.<br/>La découverte est proposée sous forme de webinaire.");
            }
            return("En deux heures, découvrez les enjeux et les outils de Lorfolio.<br/>Les séances de découverte peuvent avoir lieu sous forme de webinaires ou en présentiel.");
        },
        leTabProgramme() {
            if (this.data && this.data.evenements && this.data.evenements.length)
                return(this.data.evenements);
            return(null)
        },
    },
    created() {
        if (this.data) {
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    #containerDecouverte {
        #decouverte {
        }
        .itemProgramme {
            .icone {
                background: url("/img/pro/rencontres/icon_decouverte.svg") transparent no-repeat top left;
            }

        }
    }
</style>
